import { LModalContentsWidthType, ModalType } from '@lib/components';
import { ModalBlockParts } from '@lib/services';
import { BaggageRequestComponent } from './baggage-request.component';

/**
 * 手荷物申込画面 ペイロード(S02-M016)
 * @param BaggageRequestPayload
 */
export interface BaggageRequestPayload {}

/**
 * 手荷物申込(S02-M016)をモーダル表示する
 * モーダル呼出しパラメータ
 * const part = baggageRequestPayloadParts()
 * this.modal.showSubModal(part)
 */
export function baggageRequestPayloadParts(): ModalBlockParts {
  return {
    id: 'BaggageRequestComponent',
    block: BaggageRequestComponent,
    closeBackEnable: false,
    type: ModalType.TYPE4,
    modalWidth: LModalContentsWidthType.NONE,
    payload: {} as BaggageRequestPayload,
  };
}
